import styled from "styled-components/macro";

export const Container = styled.div`
  position: relative;

  button {
    svg {
      height: 18px;
      width: 18px;

      path {
        stroke: white;
      }
    }

    font-size: 16px;
    background: var(--primary-cta);

    &:hover {
      background: var(--primary-cta-hover);
    }

    &:disabled {
      // background: var(--grey-2) !important;
      background: none;
      cursor: default;
    }

    display: flex;
    align-items: center;
    gap: 8px;
    color: white;
    border: 0;
    border-radius: 25px;
    font-family: Inter;
    font-weight: 500;
    padding: 10px 40px;
    cursor: pointer;
    margin-top: 15px;
  }
`;
